import pak from "Assets/Images/Flag/pak.png";
import ger from "Assets/Images/Flag/ger.png";
import ksa from "Assets/Images/Flag/ksa.png";
import nig from "Assets/Images/Flag/nig.png";
import rus from "Assets/Images/Flag/rus.png";
const testimonials = [
  {
    name: "Germany",
    message:
      "All because of your guidance and dedication that he is able to perform best at school. All credits to you for your fantastic school readiness program.",
    flag: ger,
    // bgcolor: "#F54748",
  },
  {
    name: "Saudi Arabia",
    message:
      "I took ABA therapy (online) from Faiza for my son. It has been a great experience as my son makes remarkable progress in terms of behavior as well as academics. She provided all the learning material required for the session based on my child’s need including personalized IEP. Apart from that she also empowers parents.",
    flag: ksa,
    // bgcolor: "#FDC55E",
  },
  {
    name: "Russia",
    message:
      "It has been wonderful few months of therapy! Thank you for guiding me and training me on basic aba techniques. Could not have happened without your help. Your work is very unique and efficient. May needful parents find you and may you succeed ahead with them too.",
    flag: rus,
    // bgcolor: "#42A5F5",
  },
  {
    name: "Saudi Arabia",
    message:
      "What sets Faiza apart is her holistic approach—she doesn’t just focus on the child, but supports the entire family. Over the years, we’ve seen remarkable improvements in our daughter’s communication, behavior, and confidence.",
    flag: ksa,
    // bgcolor: "#FDC55E",
  },
  {
    name: "Nigeria",
    message:
      "I was honestly skeptical about teletherapy—But I took a leap of faith, and I have never looked back. She picked up on things about my son's behavior through a screen that others couldn’t even catch in person. She’s guided us every step of the way and trained us as parents to truly support our child.",
    flag: nig,
    // bgcolor: "#4CAF50",
  },
  {
    name: "Pakistan",
    message:
      "After being attached with you for some time I can confidently say that ABA is not abusive. More than grateful to have you as my son’s star therapist.",
    flag: pak,
    // bgcolor: "#66BB6A",
  },
];

export default testimonials;
